import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox as MuiCheckbox, FormControlLabel } from '@mui/material';

/**
 * Checkbox - Componente atômico base para seleção de opções
 * 
 * Este componente segue o princípio do Atomic Design como um "átomo".
 * Fornece uma base consistente para caixas de seleção no sistema.
 */
const Checkbox = ({
  label,
  checked = false,
  disabled = false,
  size = 'medium',
  color = 'primary',
  className = '',
  ...props
}) => {
  return (
    <FormControlLabel
      control={
        <MuiCheckbox
          checked={checked}
          disabled={disabled}
          size={size}
          color={color}
          className={`base-checkbox ${className}`}
          {...props}
        />
      }
      label={label}
    />
  );
};

Checkbox.propTypes = {
  /** Rótulo do checkbox */
  label: PropTypes.string,
  /** Estado do checkbox */
  checked: PropTypes.bool,
  /** Se o checkbox está desabilitado */
  disabled: PropTypes.bool,
  /** Tamanho do checkbox */
  size: PropTypes.oneOf(['small', 'medium']),
  /** Cor do checkbox */
  color: PropTypes.oneOf(['primary', 'secondary', 'success', 'error', 'info', 'warning']),
  /** Classes CSS adicionais */
  className: PropTypes.string,
  /** Função chamada quando o estado muda */
  onChange: PropTypes.func,
  /** Nome do checkbox */
  name: PropTypes.string,
  /** ID do checkbox */
  id: PropTypes.string,
  /** Valor do checkbox */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
};

export default Checkbox; 